// src/pages/admin/CouponForm.jsx
import React, { useState, useEffect } from "react";
import axios from "../../axios/axios";
import Layout from "./Layout";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";

const CouponForm = () => {
  const [couponData, setCouponData] = useState({
    code: "",
    discount: "",
    usageLimit: "",
    assignedUsers: [], // array of selected user IDs (strings)
  });

  const [mode, setMode] = useState("global"); // "global" or "specific"
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get("/user/allUsers");
        // Assume API returns users with id, name, email
        const filteredUsers = res.data.filter(
          (user) =>
            user.role !== "admin" &&
            user.role !== "editor" &&
            user.role !== "manager"
        );
        setUsers(filteredUsers);
      } catch (err) {
        console.error("fetchUsers error:", err);
        toast.error("Failed to fetch users");
      }
    };
    fetchUsers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // keep discount & usageLimit as strings in UI, convert on submit
    setCouponData({ ...couponData, [name]: value });
  };

  const handleUserCheckbox = (e, userId) => {
    setCouponData((prev) => {
      if (e.target.checked) {
        return { ...prev, assignedUsers: [...prev.assignedUsers, userId] };
      } else {
        return {
          ...prev,
          assignedUsers: prev.assignedUsers.filter((id) => id !== userId),
        };
      }
    });
  };

  const handleModeChange = (e) => {
    const newMode = e.target.value;
    setMode(newMode);
    if (newMode === "global") {
      // clear assigned users for global coupon
      setCouponData((prev) => ({ ...prev, assignedUsers: [] }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Build payload
    const payload = {
      code: couponData.code.trim(),
      discount: Number(couponData.discount),
      usageLimit: Number(couponData.usageLimit),
      assignedUsers: mode === "global" ? [] : couponData.assignedUsers,
      // optional flag helpful for server-side clarity:
      isGlobal: mode === "global",
    };

    console.log("Submitting coupon payload:", payload);

    try {
      const res = await axios.post("/coupon/create", payload);
      console.log("create coupon response:", res.data);
      setCouponData({
        code: "",
        discount: "",
        usageLimit: "",
        assignedUsers: [],
      });
      setMode("global");
      toast.success("Coupon created successfully!");
    } catch (error) {
      console.error("create coupon error:", error.response || error);
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  return (
    <>
      <Navbar />
      <Layout>
        <div className="bg-light">
          <div className="col-md-8 container py-5">
            <h2 className="mb-4 fw-600">Create / Assign Coupon</h2>
            <ToastContainer theme="colored" />
            <form onSubmit={handleSubmit} className="mt-3">
              {/* Mode selector */}
              <div className="mb-3">
                <label className="form-label">Coupon Scope</label>
                <select
                  className="form-select py-3"
                  value={mode}
                  onChange={handleModeChange}
                >
                  <option value="global">Global — All users</option>
                  <option value="specific">Assign to specific users</option>
                </select>
              </div>

              {/* Coupon Code */}
              <div className="mb-3">
                <label className="form-label">Coupon Code</label>
                <input
                  type="text"
                  name="code"
                  value={couponData.code}
                  onChange={handleChange}
                  className="form-control py-3 rounded-2"
                  placeholder="Enter coupon code"
                  required
                />
              </div>

              {/* Discount */}
              <div className="mb-3">
                <label className="form-label">Discount (%)</label>
                <input
                  type="number"
                  name="discount"
                  value={couponData.discount}
                  onChange={handleChange}
                  className="form-control py-3 rounded-2"
                  placeholder="Enter discount percentage"
                  min="0"
                  required
                />
              </div>

              {/* Usage Limit */}
              <div className="mb-3">
                <label className="form-label">Usage Limit</label>
                <input
                  type="number"
                  name="usageLimit"
                  value={couponData.usageLimit}
                  onChange={handleChange}
                  className="form-control py-3 rounded-2"
                  min="1"
                  required
                />
              </div>

              {/* Assign Users (only when specific mode) */}
              {mode === "specific" && (
                <div className="mb-3">
                  <label className="form-label">
                    Assign to Users (leave empty for no assignment)
                  </label>
                  <div
                    className="border p-3 rounded"
                    style={{ maxHeight: "200px", overflowY: "auto" }}
                  >
                    {users.length > 0 ? (
                      users.map((user) => (
                        <div key={user.id} className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`user-${user.id}`}
                            name="assignedUsers"
                            checked={couponData.assignedUsers.includes(
                              String(user.id)
                            )}
                            onChange={(e) =>
                              handleUserCheckbox(e, String(user.id))
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`user-${user.id}`}
                          >
                            {user.name} ({user.email})
                          </label>
                        </div>
                      ))
                    ) : (
                      <p>No users available</p>
                    )}
                  </div>
                </div>
              )}

              <button
                type="submit"
                className="btn bg_maincolor text-light mt-3"
              >
                Create Coupon
              </button>
            </form>
          </div>
        </div>
      </Layout>
      <Footer />
    </>
  );
};

export default CouponForm;
